import { render, staticRenderFns } from "./SelectOrderSourceType.vue?vue&type=template&id=a4b38a80&scoped=true&"
import script from "./SelectOrderSourceType.vue?vue&type=script&lang=ts&"
export * from "./SelectOrderSourceType.vue?vue&type=script&lang=ts&"
import style0 from "./SelectOrderSourceType.vue?vue&type=style&index=0&id=a4b38a80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b38a80",
  null
  
)

/* custom blocks */
import block0 from "./SelectOrderSourceType.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports